import $ from 'jquery';
import AmazonBodyText from './components/Article/ArticleModules/BodyText/AmazonBodyText';
import { SITE_HOST, APP_ENV, AUTHOR_IMAGE_PLACEHOLDER, AFFILIATE_URLS, INTERNAL_URLS, } from './consts';

// Private
const lowercaseObjectValues = obj => Object.keys(obj).reduce((lowercasedObj, key) => {
  if((isValid(obj[key])) && (isValid(lowercasedObj))) {
    if(isNaN(obj[key])) {
      lowercasedObj[key] = obj[key] ? obj[key].toLowerCase() : null;
    } else {
      lowercasedObj[key] = obj[key];
    }
  }
  return lowercasedObj;
}, {});


// Public
export const isServer = (typeof (window) === 'undefined');

export const isValid = (val) => {
  if ((typeof(val) === 'undefined') || val === null) {
    return false;
  } else if (Array.isArray(val)) {
    return (val.length > 0);
  } else {
    return true;
  }
}

export const isText = (str) => {
  if (!isValid(str)) {
    return false;
  }
  return ((typeof(str) === "string") && (str !== ''));
}

export const getRelValue = (link, isLargeImage = false) => {
  if (!isText(link)) return null;
  const isPureWowLink = link.includes("purewow.com") || link.includes("purewow.net");
  const isAffiliateLink = AFFILIATE_URLS.some(el => link.includes(el));

  if (isPureWowLink && isLargeImage) {
    return null;
  } else if (isAffiliateLink) {
    return "noopener sponsored noskim";
  } else {
    return "noopener nofollow";
  }
}

export const getRelValueOutboundLink = (link, rel) => {
  let relValue = null;
  if (isText(link)) {
    const isInternalLink = INTERNAL_URLS.some(el => link.includes(el));
    relValue = isInternalLink ? '' : rel;
  }
  return relValue;
}

export const relAttr = (rel) => {
  if (rel) {
    return { rel };
  }
  return {};
};

const hasSpecialCharacters = (str) => {
  if (!isValid(str)) {
    return null
  } else {
    return /[~`!#$%\^*()@&+=.[\]\\'; ,\/{}|\\":<>\?]/g.test(str);
  }
}

const testPath = (path) => {
  const [pathWithoutQuery, queryString] = path.split('?');
  if (typeof queryString !== 'undefined' && queryString !== 'isVertical=true') {
    return false;
  }
  const testPath = pathWithoutQuery.replace("/api/", "");
  let cat = null;
  let slug = null;
  let isArticle = false;
  let isValidPath = true;
  const urlArr = testPath.split("/");
  if (isValid(urlArr)) {
    cat = urlArr[0];
    if (urlArr.length > 1) {
      isArticle = true;
      slug = urlArr[1];
    }
  }
  if (cat === 'static' || hasSpecialCharacters(cat)) {
    isValidPath = false;
  }
  if (isArticle && hasSpecialCharacters(slug)) {
    isValidPath = false;
  }
  return isValidPath;
};

export const fetchData = async (fetchPath) => {
  const completePath = `${SITE_HOST}${fetchPath}`;
  const isValidPath = testPath(fetchPath);
  if (isValidPath) {
    return await fetch(completePath, {
      headers: {
        Accept: 'application/json',
      },
      redirect: 'follow',
    }).then(data => {
      return data.json();
    }).catch(e => {
      console.log('fetch failed:', e);
      // explicitly returns null for errors which results in 404 page loading instead of page breaking
      return null;
    });
  } else {
    return null;
  }
};

export const topOfPage = () => {
  if (typeof window !== 'undefined') {
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(`topOfPage error: ${e}`);
    }
  }
};

export const scrollToTopOf = (element, offset = 0, speed = 400, callback = () => {}) => {
  const $element = $(element);
  if ($element.length) {
    $('html, body').animate({
      scrollTop: $element.offset().top - offset,
    }, speed, 'swing', callback);
  }
};

export const convertHexToRGBA = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);


  const g = parseInt(hex.slice(3, 5), 16);


  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r},${g},${b},${alpha})`;
};

// modified copy of same function from Helmet source code
export const encodeSpecialCharacters = (str) => {
  if (!isValid(str)) {
    return null;
  }
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;");
};

export const decodeSpecialCharacters = (str) => {
  if (!isValid(str)) {
    return null;
  }
  return String(str)
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#x2013;/g, "–")
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#x2019;/g, "’")
    .replace(/&#xE9;/g, "é")
    .replace(/&#xFEFF;/g, "");
};

export const encodeHTML = html => {
  if (!isValid(html) || (typeof html === "string" && html.length === 0)) {
    return "";
  }

  return html.replace(/[\u00A0-\u9999<>\&]/gim, i => `&#${i.charCodeAt(0)};`);
}

export const encodeTitle = (str) => {
  if (!isValid(str)) {
    return null;
  }
  if (str.indexOf("'") !== -1 || str.indexOf('"') !== -1) {
    return encodeHTML(str);
  }
  else {
    return encodeSpecialCharacters(str);
  }
}


export const decodeHTML = (str) => {
  if (!isValid(str)) {
    return null;
  }
  let decodedStr = null;
  try {
    decodedStr = str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
  } catch (e) {
    console.log(e);
  } finally {
    return decodedStr;
  }
};

export const decodeTags = (str) => {
  if (!isValid(str)) {
    return null;
  }
  let decodedStr = null;
  try {
    decodedStr = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  } catch (e) {
    console.log(e);
  } finally {
    return decodedStr;
  }
};

export const removeTags = (str) => {
  if (!isValid(str)) {
    return null;
  }
  let strTagsRemoved = null;
  try {
    strTagsRemoved = str.toString();
    strTagsRemoved = str.replace(/(<([^>]+)>)/ig, '');
  } catch (e) {
    console.log(e);
  } finally {
    return strTagsRemoved;
  }
};

export const toggleScrollLock = () => {
  const bodyClass = document.body.classList;

  if (bodyClass.contains('lock')) {
    bodyClass.remove('lock');
  } else {
    bodyClass.add('lock');
  }
};

export const getIsTrackable = () => {
  const privacyCookie = getCookie('usprivacy');
  if (isValid(privacyCookie)) {
    const privacyArray = privacyCookie.split('');
    if (privacyArray[2] === 'Y') {
      return false;
    }
  }
  return true;
}

// track Segment Page event
export const segmentTrackPage = (title, baseTracker = {}) => {
  const formattedTracker = lowercaseObjectValues({
    ...baseTracker,
    title,
    path: location.pathname,
    url: location.href,
    referrer: document.referrer,
    search: location.search,
  });
  const isTrackable = getIsTrackable();
  if (isTrackable) {
    analytics.page(title, formattedTracker);
    setTimeout(() => {
      analytics.page(title, formattedTracker);
    }, 3600000);
  } else {
    console.log('segmentTrackPage: not tracking page');
  }
};

// track Segment Page event within single url (receives url property via baseTracker)
export const segmentTrackComponentAsPage = (baseTracker = {}) => {
  const formattedTracker = lowercaseObjectValues({
    ...baseTracker,
    title: document.title,
    path: location.pathname,
    referrer: document.referrer,
    search: location.search,
  });
  const isTrackable = getIsTrackable();
  if (isTrackable) {
    analytics.page(formattedTracker);
  } else {
    console.log('not tracking component as page');
  }
};

// track Segment events that are not Page
export const segmentTrackEvent = (eventName, eventSpecific, baseTracker = {}) => {
  const tracker = lowercaseObjectValues({ 
    ...baseTracker, 
    ...eventSpecific,
    path: location.pathname, 
    url: location.href,
    search: location.search,
  });
  analytics.track(eventName, lowercaseObjectValues(tracker));
};

// track Segment events that are not Page
export const cerosTracking = (event) => {
  event.preventDefault();
  if (event.detail.eventType === 'link-click') {
    console.log("ceros track event: ", event.detail.componentName, event.detail.url);
    gtag('event', 'ceros_event', {'label': event.detail.componentName, 'url': event.detail.url});
  }
};

export const getFileName = (src) => {
  if (!isValid(src)) {
    return null;
  }
  try {
    const match = src.match(/[^/\\]+(?:jpg|jpeg|png|svg)/);
    return match ? match[0].replace(/(%20|-|_)/g, ' ').replace(/\.(jpg|jpeg|png|svg)/, '') : null;
  } catch (e) {
    console.log(e);
    return null;
  }
  
};

/*
this same function exists in server/transform.js. however, we've duplicated it here for now because
there is a known issue w/ importing and exporting modules between server/ and src/ which will be addressed
in the future (most likely something in the webpack setup).
*/
export const getProperty = (iterable, props = [], cb) => {
  const currentProp = iterable[props.shift()];

  if (typeof currentProp === 'undefined' || !currentProp || currentProp.length === 0) {
    return null;
  }

  if (props.length === 0) {
    return cb ? cb(currentProp) : currentProp;
  }

  return getProperty(currentProp, props, cb);
};

// Private
const buildAd = (slotName, adUnit, teadsName = false) => {
  return ({
    type: 'ad',
    data: {
      slotName: slotName, 
      adUnit: adUnit,
      teadsName: teadsName
    },
  });
}

export const getArticleModulesWithAds = (modules, adUnit, isMobile) => {
  // the ad-inserting logic can be a component method.
  const modulesNoSub = modules.filter(item => (item.type !== 'sub-head' || item.type !== 'nav-head'));
  const numOfModulesNoSub = modulesNoSub.length;
  let slotName = "purewow_incontent_top";
  let adCount = 1;
  let teadsAdCount = 1;
  let increment = (numOfModulesNoSub >= 15) ? 5 : 4; // for articles with < 15 modules on desktop and mobile, every 3 modules
  let index = 1;
  let adInsertIndex = 1;
  let teadsInsertIndex = 3;
  let teadsName = "purewow_teads";

  
  // Insert ads if more than 4 modules (not including sub-heads)
  if (!(modules.some(module => module.type === 'ad'))) {
    if (numOfModulesNoSub >= 4) {
      // Ads will appear after every 3 or 4 modules (not including subheds)
      while (index <= modules.length) {
        slotName = adCount == 1 ? "purewow_incontent_top" : "purewow_incontent";
        if (
          (
            // Check if the previous module is 'sub-head' or 'nav-head'
            (modules[index - 1].type === 'sub-head' || modules[index - 1].type === 'nav-head') 
            && index + 1 <= modules.length
          ) ||
          (
            // Check if the current module is 'call-out', 'affiliate-table-of-contents', or 'carousel'
            (index == adInsertIndex || index == teadsInsertIndex)
            && index < modules.length 
            && (modules[index].type === 'call-out' || modules[index].type === 'affiliate-table-of-contents' || modules[index].type === 'carousel')
          ) ||
          (
            // Check if the previous module is 'body-text' with word count < 100
            (index == adInsertIndex || index == teadsInsertIndex)
            && modules[index - 1].type === 'body-text'
            && modules[index - 1].data.wordCount < 100
            && index + 1 <= modules.length
          )
        ) {
          index += 1;
          adInsertIndex += 1;
          teadsInsertIndex += 1;
        }
        // Insert intersitial ads at index points, no ad after last module
        if ( index == adInsertIndex && adInsertIndex < modules.length){
          modules.splice((adInsertIndex), 0, buildAd(slotName, adUnit));
          adInsertIndex += increment;
          adCount += 1;
        }
        // Insert Teads ad after 3rd and 8th modules (not including subheds)
        if (index == teadsInsertIndex && teadsInsertIndex < modules.length && teadsAdCount <= 2 ){
          teadsName = teadsAdCount == 1 ? "purewow_teads" : `purewow_teads_2`;
          modules.splice((teadsInsertIndex), 0, buildAd("purewow_teads", adUnit, teadsName));
          adInsertIndex += 1;
          teadsAdCount += 1;
          teadsInsertIndex += ((numOfModulesNoSub >= 15) ? 8 : 9);
          // desktop 9, 10 modules needs 10
          // desktop <15 modules needs 11
          // desktop >= 15 modules needs 9
          // mobile <15 modules needs 9
          // mobile >=15 modules needs 8
        }
        index += 1;
      }
    // for articles with < 4 modules, insert teads after first non-subhed module
    } else {
      // do not insert Teads after video hero
      if (numOfModulesNoSub > 1 && modules[0].type !== 'video-embed') {
        teadsInsertIndex = (modules[0].type === 'sub-head'|| modules[0].type === 'nav-head') ? 2 : 1;
        const shortBodyTextModule = modules[teadsInsertIndex].type === 'body-text' && modules[teadsInsertIndex].data.wordCount < 100;
        if (teadsInsertIndex < modules.length && modules[teadsInsertIndex].type !== 'call-out' && modules[teadsInsertIndex].type !== 'carousel' && !shortBodyTextModule) {
          modules.splice(teadsInsertIndex, 0, buildAd("purewow_teads", adUnit, "purewow_teads"));
        }
      }
      // for mobile articles with 3 modules, ad celtra/intersitial after 2nd module
      if (numOfModulesNoSub == 3 && isMobile) {
        teadsInsertIndex += (modules[teadsInsertIndex+1] === 'sub-head' || modules[teadsInsertIndex+1] === 'nav-head') ? 3 : 2;
        const shortBodyTextModule = modules[teadsInsertIndex - 1].type === 'body-text' && modules[teadsInsertIndex - 1].data.wordCount < 100;
        if (teadsInsertIndex < modules.length && modules[teadsInsertIndex].type !== 'call-out' && modules[teadsInsertIndex].type !== 'carousel' && !shortBodyTextModule) {
          modules.splice(teadsInsertIndex, 0, buildAd("purewow_incontent_top", adUnit));
        }
      }
    }
  }
  return modules;
};

export const getSponsoredArticleWithAds = (modules, adUnit, isMobile) => {
  const modulesNoSub = modules.filter(item => (item.type !== 'sub-head' || item.type !== 'nav-head'));
  const numOfModulesNoSub = modulesNoSub.length;
  let slotName = "purewow_incontent_top";
  let adCount = 1;
  let increment = (numOfModulesNoSub >= 15) ? 5 : 4; // for articles with < 15 modules on desktop and mobile, every 3 modules
  let index = 1;
  let adInsertIndex = 1;

  // Insert ads if more than 4 modules (not including sub-heads)
  if (!(modules.some(module => module.type === 'ad'))) {
    if (numOfModulesNoSub >= 4) {
      // Ads will appear after every 3 or 4 modules (not including subheds)
      while (index <= modules.length) {
        slotName = adCount == 1 ? "purewow_incontent_top" : "purewow_incontent";
        // increase index positions each time there is a sub-head
        if (
          (
            // Check if the previous module is 'sub-head' or 'nav-head'
            (modules[index - 1].type === 'sub-head' || modules[index - 1].type === 'nav-head') 
            && index + 1 <= modules.length
          ) ||
          (
            // Check if the current module is 'call-out' or 'carousel' and matches adInsertIndex
            index == adInsertIndex 
            && index < modules.length 
            && (modules[index].type === 'call-out' || modules[index].type === 'carousel')
          )
        ) {
          index += 1;
          adInsertIndex += 1;
        }
        // Insert intersitial ads at index points, no ad after last module
        if ( index == adInsertIndex && adInsertIndex != modules.length){
          modules.splice((adInsertIndex), 0, buildAd(slotName, adUnit));
          adInsertIndex += increment;
          adCount += 1;
        }
        index += 1;
      }
    // for mobile articles with 3 modules, ad intersitial after 2nd module
    } else if (numOfModulesNoSub == 3 && isMobile) {
      adInsertIndex += (modules[1].type === 'sub-head' || modules[1].type === 'nav-head') ? 2 : 1;
      if (modules[adInsertIndex].type !== 'call-out'|| modules[adInsertIndex].type !== 'carousel') {
        modules.splice(adInsertIndex, 0, buildAd("purewow_incontent_top", adUnit ));
      }
    }
  }
  return modules;
};

export const getQuizWithAds = (modules, adUnit) => {
  modules.splice(1, 0, buildAd("purewow_incontent_top", adUnit));
  return modules;
}


export const getContentHubWithAds = (modules, adUnit, isMobile) => {
  // What is ad Unit for content hub
  const navHeads = modules.filter(module => module.type === 'nav-head');
  let slotName = "purewow_incontent_top";
  let adCount = 1;
  if (!(modules.some(module => module.type === 'ad'))) {
    // if Content Hub contains nav-heads, insert ad before each nav-head aslong as previous module is not related tag with 3 or more rows for deskop or previous module is not related tags for mobile
    if (navHeads && navHeads.length > 0) {
      for (let i = 0; i < modules.length; i++) {
        slotName = adCount == 1 ? "purewow_incontent_top" : "purewow_incontent";
        if (modules[i].type === "nav-head" && !(( !isMobile && (modules[i - 1].type === "related-tags") && (modules[i - 1].data.rows > 2)) || (isMobile && (modules[i - 1].type === "related-tags"))))  {
          modules.splice(i, 0, buildAd(slotName, adUnit ));
          adCount++;
          i++;
        }
      }
    }
    // if no nav-heads, insert ads every 3 modules
    else {
      for (let i = 1; i < modules.length; i += 3) {
        // do not include ad if previous module is Related Tags with 3 or more rows
        if (!(( !isMobile && (modules[i - 1].type === "related-tags") && (modules[i - 1].data.rows > 2)) || (isMobile && (modules[i - 1].type === "related-tags")))) {
          slotName = adCount == 1 ? "purewow_incontent_top" : "purewow_incontent";
          modules.splice(i, 0, buildAd(slotName, adUnit));
          adCount++;
          i++;;
        }
      }
    }
  }
  return modules;
};

export const getGuideWithAds = (modules, adUnit, isMobile, isSponsored) => {
  let adCount = 1;
  if (!(modules.some(module => module.type === 'ad'))) {
    if (isSponsored) {
      modules.splice(1, 0, buildAd("purewow_incontent", adUnit));
    }
    else {
      const modulesNoSub = modules.filter(item => (item.type !== 'sub-head' || item.type !== 'nav-head'));
      const numOfModulesNoSub = modulesNoSub.length;
      let slotName = "purewow_incontent_top";
      let teadsAdCount = 1;
      let increment = 4; // for articles with < 15 modules on desktop and mobile, every 3 modules
      let index = 1;
      let adInsertIndex = 1;
      let teadsInsertIndex = 3;
      let teadsName = "purewow_teads";
      // for articles with >= 15 modules, every 4 modules on desktop and mobile
      increment = (numOfModulesNoSub >= 15) ? 5 : increment;
  
      // Ads will appear after every 3 or 4 modules (not including subheds)
      while (index <= modules.length) {
        slotName = adCount == 1 ? "purewow_incontent_top" : "purewow_incontent";
        if (
          (
            // Check if the previous module is 'sub-head'
            (modules[index - 1].type === 'sub-head' || modules[index - 1].type === 'nav-head') 
            && index + 1 <= modules.length
          ) ||
          (
            // Check if the current module is 'call-out' or 'carousel' and matches adInsertIndex
            index == adInsertIndex 
            && index < modules.length 
            && (modules[index].type === 'call-out' || modules[index].type === 'carousel')
          )
        ) {
          index += 1;
          adInsertIndex += 1;
          teadsInsertIndex += 1;
        }
        // Insert intersitial ads at index points, no ad after last module
        if ( index == adInsertIndex && adInsertIndex < modules.length){
          modules.splice((adInsertIndex), 0, buildAd(slotName, adUnit));
          adInsertIndex += increment;
          adCount += 1;
        }
        // Insert Teads ad after 3rd and 8th modules (not including subheds)
        if (index == teadsInsertIndex && teadsInsertIndex < modules.length && teadsAdCount <= 2 ){
          teadsName = teadsAdCount == 1 ? "purewow_teads" : `purewow_teads_2`;
          modules.splice((teadsInsertIndex), 0, buildAd("purewow_teads", adUnit, teadsName));
          adInsertIndex += 1;
          teadsAdCount += 1;
          teadsInsertIndex += ((isMobile && numOfModulesNoSub >= 15) ? 8 : 9);
        }
        index += 1;
      }
    }
  }
  return modules;
};

export const getRecirculationData = async () => {
  const data = await fetchData('/api/home');
  return data.articles;
};

export const makeStaticAdsResponsive = (slotFrame, slotImg, id) => {
  const handleResize = () => {
    const imgHeight = slotImg.clientHeight;
    if (imgHeight != 0) {
      slotFrame.style.height = imgHeight + "px";
    }
  }
  
  if (slotImg && !slotImg.src.includes("celtra")) {
    slotImg.style.height = "auto";
    slotImg.style.width = "100%";
    if (slotImg.clientHeight != 0) {
      slotFrame.style.height = slotImg.clientHeight + "px";
    }
    else {
      setTimeout(handleResize, 500);
    }
    window.addEventListener('resize', handleResize);
  }
}

export const sendLog = (component, level, message) => {
  const codedMessage = message.replace(/ /g, '-');
  const fetchURL = `${SITE_HOST}/log/${component}/${level}/${codedMessage}`;
  fetch(fetchURL, {
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => console.log('SRC response:', res.status))
    .catch(rejected => {
      console.log('NOPE:', rejected);
    });
};

export const createCookie = (cname, expiration, cvalue) => {
  const d = new Date();
  d.setTime(d.getTime() + expiration);
  const expires = 'Expires=' + d.toUTCString();
  const secstr = APP_ENV !== 'PROD' ? '' : ';Secure'; // omit secure flag if we are debug mode (used for localhost)

  document.cookie = `${cname}=${cvalue};${expires};Path=/;SameSite=Lax;${secstr}`;
}

export const getCookie = (name) => {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}


// NOTE ON COOKIES:
// we're doing combination cookies + jwTokens because universal apps aren't
// single page apps (SPAs). Server-rendered requests, when triggered via
// direct visits by the user, do not have headers we can set. That's the
// takeaway.

/* Logic for when subhed length is between > x & x chars, truncate bodyText to x chars. Includes logic for edge cases when last character is punctuation, to remove it. */
export const truncate = (input) => {
  let final;
  const regex = /\s*$|\W*$/;
  if (isValid(input) && input.length >= 187) {
    final = input.substring(0, 187).replace(regex, '');
    return `${final}...`;
  }
  final = input;
  return final;
};

export const trimmed = (input, length = 180) => {
  let final;
  const maxLength = length; // maximum number of characters to extract
  const regex = /\s*$|\W*$/;
  if (isValid(input) && input.length >= maxLength) {
    final = input.substring(0, maxLength);
    //re-trim if we are in the middle of a word and remove punctuation if it's the last character
    final = final.substr(0, Math.min(final.length, final.lastIndexOf(' '))).replace(regex, '');
    return `${final}...`;
  }
  final = input;
  return final;
};

// Used in AuthorBios.js and SecondaryAuthorBio.js
export const makeAuthorImgLink = (str) => {
  return str;
};

// Web Vitals
let webVitalsObj = {};

export const addToWebVitals = (metric) => {
  const metricName = metric.name;
  const webVitalsMetric = { "value": metric.value, "rating": metric.rating, "navigationType": metric.navigationType };
  if (Object.keys(webVitalsObj).length === 0) {
    const date = new Date();
    webVitalsObj["date"] = date;
    webVitalsObj["url"] = window.location.href;
  }
  webVitalsObj[metricName] = webVitalsMetric;
}

export const flushWebVitals = () => {
  if (Object.keys(webVitalsObj).length !== 0) {
    analytics.track('web_vitals', webVitalsObj);
    webVitalsObj = {};
  }
}


export const convertArticlesToArray = (object) => {
  if (!isValid(object)) {
    return;
  }

  const articlesArray = Object.keys(object)
    .filter(key => key.startsWith('article'))
    .map(key => object[key]);

  return {
    title: object.title,
    articles: articlesArray
  };

}

export const pushHtlCommand = (context, cb, attempt = 0) => {
  if (typeof window === 'undefined') return;

  const maxAttempts = 10;
  const delay = 150;

  if (window.htlbid && window.htlbid.cmd) {
    console.log(`[HTL][${context}] pushing cmd at attempt ${attempt}`);
    window.htlbid.cmd.push(cb);
    return;
  }

  if (attempt >= maxAttempts) {
    console.log(
      `[HTL][${context}] giving up after ${attempt} attempts – htlbid/cmd still not ready`
    );
    return;
  }

  console.log(
    `[HTL][${context}] htlbid/cmd not ready, retrying in ${delay}ms (attempt ${attempt + 1})`
  );

  setTimeout(() => pushHtlCommand(context, cb, attempt + 1), delay);
}

export const setHtlTargetingAndPageview = ({ context, targeting }) =>  {
  if (typeof window === 'undefined') return;

  window.__pwHtlHasLaidOut = window.__pwHtlHasLaidOut || false;

  pushHtlCommand(context, () => {
    const firstLoad = !window.__pwHtlHasLaidOut;

    try {
      htlbid.clearTargeting();

      Object.entries(targeting || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        htlbid.setTargeting(key, `${value}`);
      });

      if (firstLoad) {
        window.__pwHtlHasLaidOut = true;
        htlbid.layout();
      } else {
        htlbid.newPage();
      }
    } catch (err) {
      console.log('setHtlTargetingAndPageview error calling newPage/layout', err);
    }
  });
};

